<script>
import lazyLoadComponent from '@router/lazyload-component'
import formatDate from '@utils/format-date'
import { orderPaymentMethodMap, paymentStatusMapFilter } from '@utils/filter-value-to-text'

export default {
  filters: {
    formatDate,
    paymentStatusMapFilter
  },
  components: {
    BaseStateLabel: () => lazyLoadComponent(import('@components/BaseStateLabel')),
  },
  props: {
    defaultValue: {
      type: Object,
      default: () => {},
    },
    installmentData: {
      type: Array,
      default: () => {
        return []
      },
    }
  },
  data() {
    return {
      orderPaymentMethodMap,
    }
  },
  mounted() {
    console.log(this.defaultValue)
  },
  methods: {
    paidAt(data) {
      if (!!data.paidAt === false) return '無'
      return formatDate(data.paidAt, 'dateTime')
    },
    paymentExpiredDate(data) {
      if (data.allowExpired === 1) return '無（可逾期付款）'
      return formatDate(data.paymentExpiredDate, 'dateTime')
    },
    getPaymentStatus(data, property = "text") {
      if(!data) {
        let chk = this.defaultValue.installments.find((item) => {
          return item.paymentStatus !== "PAID"
        })
        if(chk) {
          data = "UNPAID"
        } else {
          data = "PAID"
        }
      }
      return paymentStatusMapFilter(data, property)
    }
  },
}
</script>
<template>
  <ul :class="$style.payment" class="p-3">
    <li>
      <span class="title">付款方式</span><span class="content">{{ orderPaymentMethodMap[defaultValue.paymentMethod] || '不指定' }}</span>
      <span v-if="defaultValue.prepaid">
        <span v-if="defaultValue.paymentMethod === 'Prepaid'" style="color: lightgray">（{{ defaultValue.prepaid.title }}）</span>
      </span>
    </li>
    <li v-if="defaultValue.paymentMethod === 'Prepaid' && defaultValue.prepaid">
      <span class="title">抵扣次數</span>
      <span class="content">{{ defaultValue.prepaid.deductTimes }} 次 </span>
    </li>
    <li v-if="defaultValue.paymentMethod !== 'Installment'">
      <span class="title">付款時間</span>
      <span class="content">{{ paidAt(defaultValue) }}</span>
    </li>
    <li v-if="defaultValue.paymentMethod !== 'Vacc' && defaultValue.paymentMethod !== 'Prepaid' && defaultValue.paymentMethod !== 'Installment'">
      <span class="title">付款期限</span>
      <span class="content">{{ paymentExpiredDate(defaultValue) }}</span>
    </li>
    <template v-if="defaultValue.paymentMethod === 'Installment'">
      <li>
        <span class="title">分期次數</span>
        <span class="content">{{ installmentData.length  }} 期 </span>
      </li>
      <li>
        <div class="title">付款詳情</div>
        <span class="content">
          <BaseStateLabel :state="getPaymentStatus(defaultValue.paymentStatus, 'color')" text>
            {{ getPaymentStatus(defaultValue.paymentStatus, "text") }}
          </BaseStateLabel>
          <div v-for="(installment, index) in installmentData" :key="index">
            <div v-if="installment.paymentStatus === 'PAID'">
              第{{ installment.no }}期付款 NT${{ installment.amount }}<br>
              {{ installment.paidAt }} {{ orderPaymentMethodMap[installment.paymentMethod] || '不指定' }}
            </div>
          </div>
        </span>
      </li>
    </template>
    <template v-if="defaultValue.Vacc">
      <li style="border-top: 1px solid #dcdfe6">
        <span class="title">轉帳銀行</span>
        <span class="content">{{ `${defaultValue.Vacc.Bank} ${defaultValue.Vacc.BankCode}` }}</span>
      </li>
      <li>
        <span class="title">轉帳帳號</span>
        <span class="content">{{ defaultValue.Vacc.VACCNo }}</span>
      </li>
      <li>
        <span class="title">轉帳期限</span>
        <span class="content">{{ defaultValue.paymentExpiredDate | formatDate('dateTime') }}</span>
      </li>
    </template>
    <template v-if="defaultValue.Card4No">
      <li>
        <span class="title">信用卡末四碼</span>
        <span class="content">{{ defaultValue.Card4No }}</span>
      </li>
    </template>
    <template v-if="defaultValue.PayerAccount5Code">
      <li>
        <span class="title">匯款帳號末五碼</span>
        <span class="content">{{ defaultValue.PayerAccount5Code }}</span>
      </li>
    </template>
  </ul>
</template>
<style lang="scss" module>
.payment {
  // padding: 0 15px 10px 15px;
  :global {
    li {
      display: flex;
      line-height: 40px;
    }
    .title {
      margin-right: 20px;
      // color: darkgray;
    }
    .content {
      color: $color-secondary;
    }
  }
}
</style>
